module.exports = "/images/vendor/esri-leaflet-geocoder/dist/search@2x.png?e3c26a437d320330174bf0973b075a84";